<template>
  <hm-content title="分类列表" class="scheduling">
    <div slot="header">
      <hm-step :steps="steps" :step="2"></hm-step>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="toAddCategory"
          >新增分类</el-button
        >
      </div>
      <div>
        <el-select
          clearable
          v-model="storeOutletId"
          placeholder="选择门店"
          size="small"
          filterable
          class="mr10"
        >
          <!-- <el-option label="全部门店"
                     :value="0"></el-option> -->
          <el-option
            v-for="item in storeList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="isShow"
          placeholder="是否显示"
          size="small"
          class="mr10"
          clearable
        >
          <el-option label="是" :value="1"> </el-option>
          <el-option label="否" :value="0"> </el-option>
        </el-select>
        <el-input
          v-model="name"
          class="mr10"
          placeholder="请输入分类名称"
          size="small"
          clearable
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="search"
          placeholder="输入名称"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="serviceCategoryList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          width="50"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="分类名称"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="所属门店">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
               
              :content="scope.row.storeOutlet"
              placement="top"
            >
              <span>{{ scope.row.storeOutlet }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="description"
          label="分类说明"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="是否显示">
          <template slot-scope="scope">
            {{ scope.row.isShow === 0 ? "否" : "是" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop=""
          label="分类排序"
        >
          <template slot-scope="scope">
            <el-input
              @blur="sortCategory(scope.row)"
              @input="scope.row.rank = scope.row.rank.replace(/\D/g, '')"
              type="number"
              v-model="scope.row.rank"
              size="small"
              class="table-input"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="remove(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="serviceCategoryList.total"
        @current-change="paging"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="新增分类"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择门店：" prop="storeOutletId">
          <el-select
            clearable
            v-model="ruleForm.storeOutletIds"
            placeholder="选择门店（可多选）"
            multiple
            size="small"
            filterable
            class="mr10 multiple-select"
          >
            <!-- <el-option label="全部门店"
                       :value="0"></el-option> -->
            <el-option
              v-for="item in storeList.list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称：" prop="name">
          <el-input
            size="small"
            v-model.trim="ruleForm.name"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="rank">
          <el-input
            size="small"
            @mousewheel.prevent.native
            clearable
            type="number"
            v-model.trim="ruleForm.rank"
          ></el-input>
          <span class="form-tip">（只能输入整数，数字越小排序越靠前）</span>
        </el-form-item>
        <el-form-item label="分类描述：">
          <el-input
            size="small"
            clearable
            v-model.trim="ruleForm.description"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否展示：">
          <el-switch
            v-model="ruleForm.isShow"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import HmStep from "@/components/HmStep";

export default {
  data() {
    return {
      steps: [
        {
          link: "StoreList",
          name: "门店列表"
        },
        {
          link: "ServiceCategory",
          name: "服务分类列表"
        },
        {
          link: "ServiceList",
          name: "项目列表"
        },
        {
          link: "StaffList",
          name: "技师列表"
        }
      ],
      dialogFormVisible: false,
      currentPage: 1,
      storeOutletId: "",
      mode: "",
      isShow: "",
      name: "",
      currentRowId: "",
      pageSize: 10,
      ruleForm: {
        name: "",
        rank: "",
        description: "",
        isShow: 1,
        storeOutletIds: []
      },
      rules: {
        storeOutletIds: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        },
        name: {
          required: true,
          message: "请输入分类名称",
          trigger: "blur"
        },
        rank: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur"
          },
          {
            message: "请输入大于0的整数",
            trigger: "blur",
            pattern: /^[1-9]\d*$/
          }
        ]
      }
    };
  },
  computed: mapGetters(["serviceCategoryList", "storeList"]),
  created() {},
  mounted() {
    this.queryList();
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
  },
  watch: {},
  methods: {
    search() {
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryServiceCategoryList", {
        name: this.name,
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        isShow: this.isShow,
        storeOutletId: this.storeOutletId
      });
    },
    sortCategory(row) {
      const params = {};
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          params[key] = row[key];
        }
      }
      params.storeOutletIds =
        row.storeOutletId.split(",").map(item => +item) || [];
      params.id = row.id;
      this.$store.dispatch("editServiceCategory", params).then(() => {
        this.queryList();
      });
    },
    toAddCategory() {
      this.dialogFormVisible = true;
      this.mode = "add";
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.currentRowId = row.id;
      this.mode = "edit";
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
      this.ruleForm.storeOutletIds =
        row.storeOutletId.split(",").map(item => +item) || [];
    },
    remove(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("deleteServiceCategory", { id }).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "删除分类成功！",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this.ruleForm) {
        this.ruleForm[key] = "";
      }
      this.ruleForm.storeOutletIds = [];
      this.ruleForm.isShow = 1;
      this.dialogFormVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let actionName;
          let params = this.ruleForm;
          if (this.mode === "add") {
            actionName = "addServiceCategory";
          } else if (this.mode === "edit") {
            actionName = "editServiceCategory";
            params = Object.assign(params, { id: this.currentRowId });
          }
          this.$store.dispatch(actionName, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.resetForm(formName);
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  components: { HmStep }
};
</script>
